import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import { MaterialModule } from "src/app/app.materials";

@Component({
  selector: 'app-datawrapper-help-dialog',
  templateUrl: './datawrapper-help-dialog.component.html',
  styleUrls: ['./datawrapper-help-dialog.component.scss'],
  imports: [MaterialModule],
  standalone: true,
})
export class DatawrapperHelpDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DatawrapperHelpDialogComponent>
  ) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
